// Typelizer digest 6598f0f2a2ececf82b4474007aff8f83
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/manual_journals */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/ledger/manual_journals */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/ledger/manual_journals/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals/new', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/ledger/manual_journals/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/ledger/manual_journals/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/ledger/manual_journals/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals/:id', params, options),
    method: 'delete',
  }),
}
